import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {PERSON_GENDER, SCHEMA_TYPE} from "./consts";
import {NationalitySchemaModel} from "./nationality-schema-model";

export class PersonSchemaDataModel extends BaseSchemaDataModel {
  birthDate: String;
  nationality: NationalitySchemaModel;
  image: String;
  gender: Number;
  affiliation: BaseSchemaModel;
}

export class PersonSchemaModel extends BaseSchemaModel {
  model: PersonSchemaDataModel;

  constructor(model: PersonSchemaDataModel) {
    super(SCHEMA_TYPE.person, model.name, model.url);

    this.model = model;
  }

  get birthDateParams(): String {
    return this.model.birthDate ? `,"birthDate": "${this.model.birthDate.toString()}"` : '';
  }

  get nationalityParams(): String {
    return this.model.nationality ? `,"nationality": {${this.model.nationality.toString()}}` : '';
  }

  get imageParams(): String {
    return this.model.image ? `,"image": "${this.model.image.toString()}"` : '';
  }

  get genderParams(): String {
    return this.model.gender ? `,"gender": "${PERSON_GENDER[this.model.gender]}"` : '';
  }

  get affiliationParams(): String {
    return this.model.affiliation ? `,"affiliation": {${this.model.affiliation.toString()}}` : '';
  }


  toString(): String {
    return `${super.toString()}${this.birthDateParams}${this.nationalityParams}${this.imageParams}${this.genderParams}${this.affiliationParams}`;
  }
}
